import { render } from "./AllEmails.vue?vue&type=template&id=f5f56f4a&scoped=true"
import script from "./AllEmails.vue?vue&type=script&lang=js"
export * from "./AllEmails.vue?vue&type=script&lang=js"

import "./AllEmails.vue?vue&type=style&index=0&id=f5f56f4a&scoped=true&lang=css"
import "./AllEmails.vue?vue&type=style&index=1&id=f5f56f4a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f56f4a"]])

export default __exports__